import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from '@services/customers/customer.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { CustomerSelectionComponent } from '../../../../../components/popUpSelects/customer-selection/customer-selection.component';
import { OrganisationSelectionComponent } from '../../../../../components/popUpSelects/organisation-selection/organisation-selection.component';

@Component({
    selector: 'app-composition-wizard-customer-select',
    templateUrl: './composition-wizard-customer-select.component.html',
    styleUrls: ['./composition-wizard-customer-select.component.scss'],
    providers: [CustomerService, OrganisationCustomerService],
    standalone: false
})
export class CompositionWizardCustomerSelectComponent implements OnInit {

  public customerType = true;
  public entranceType: string;
  public selectedCustomerId: string = null;
  public customer = null;
  public readonly = false;
  public noCategories = false;
  public ownerOrganisationID = null;
  public edit = false;

  public entranceTypes = [
    { value: 'information', title: 'Information' }, { value: 'activity', title: 'Activity' }, { value: 'alphabet', title: 'Alphabet' },
    { value: 'breaking-news', title: 'Breaking News' }, { value: 'event', title: 'Event' }, { value: 'feedback', title: 'Feedback' }, { value: 'gallery', title: 'Gallery' },
    { value: 'gastronomy', title: 'Gastronomy' }, { value: 'offer', title: 'Offer' }, { value: 'opening-hours', title: 'Öffnungszeiten' }, { value: 'person', title: 'Person' },
    { value: 'quiz', title: 'Quiz' }, { value: 'restaurant', title: 'Restaurant' }, { value: 'roomservice', title: 'Room Service' }, { value: 'screensaver', title: 'Screensaver' },
    { value: 'social-media', title: 'Social Media' }, { value: 'ticker', title: 'Ticker' }, { value: 'voting', title: 'Voting' }, { value: 'voucher', title: 'Voucher' },
    { value: 'webcam', title: 'Webcams' }, { value: 'important-numbers', title: 'Wichtige Nummern' }
  ]

  constructor(
    public dialogRef: MatDialogRef<CompositionWizardCustomerSelectComponent>,
    public customerService: CustomerService,
    public organisationCustomerService: OrganisationCustomerService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    if (!!this.data) { // edit
      this.customerType = !!this.data.id;
      this.selectedCustomerId = this.data.id;
      this.entranceType = this.data.type;
      this.edit = true;
      this.readonly = this.data.readonly;
      this.noCategories = this.data.noCategories;
      this.ownerOrganisationID = this.data.ownerOrganisationID

      this.fetchCustomer();
    } else { // create
      this.data = {};
      this.entranceType = 'information';
    }
  }

  assignCustomer() {
    let dialogRef: MatDialogRef<CustomerSelectionComponent>;
    const config: MatDialogConfig = {
      data: {
        ids: [this.selectedCustomerId],
        type: 'organisationCustomer'
      }
    };

    dialogRef = this.dialog.open(CustomerSelectionComponent, config);

    return dialogRef.afterClosed().toPromise().then(result => {
      if (result) {
        this.customerType = result.customerType;
        this.selectedCustomerId = result.customerId;
        this.customer = null;
        this.fetchCustomer();
      }
    });
  }

  assignOrganisation() {
    let dialogRef: MatDialogRef<OrganisationSelectionComponent>;
    dialogRef = this.dialog.open(OrganisationSelectionComponent, {});
    return dialogRef.afterClosed().toPromise().then(result => {
      if (result) {
        this.ownerOrganisationID = result.OrganisationID;
      }
    })
  }

  removeCustomer(event) {
    if (event && event.checked) {
      this.selectedCustomerId = null;
      this.customer = null;
      this.customerType = false
    } else {
      this.customerType = true;
    }
  }

  save() {
    this.dialogRef.close({
      customerId: this.selectedCustomerId,
      customerType: this.customerType,
      entranceType: this.entranceType,
      readonly: this.readonly,
      noCategories: this.noCategories,
      ownerOrganisationID: this.ownerOrganisationID,
      config: this.data.config
    });
  }

  private fetchCustomer() {
    this.organisationCustomerService.find(0, 1, { _id: this.selectedCustomerId }).then(organisationCustomer => {
      if (organisationCustomer.data && organisationCustomer.data.length) {
        this.customer = organisationCustomer.data[0].organisationName;
        return;
      }
      this.customerService.find(0, 1, { _id: this.selectedCustomerId }).then(customer => {
        if (customer.data && customer.data.length) {
          this.customer = customer.data[0].company;
        }
      })
    });
  };
}
